/* eslint-disable react/jsx-boolean-value */
import RemoveFromGroupPlay from './RemoveFromGroupPlay';
import AddToGroupPlay from './AddToGroupPlay';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

/**
 * Share Link Lesson Action Container
 */
const defaultProps = {
  onSaveSuccess: () => { },
  className: '',
};

export default function AddRemoveFromGroupPlay(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { lesson, className, onSaveSuccess } = mergedProps;
  const { meta: { groupPlay } } = lesson;

  if (groupPlay) {
    return (
      <RemoveFromGroupPlay
        lesson={lesson}
        className={className}
        onSaveSuccess={onSaveSuccess}
      />
    );
  }

  return (
    <AddToGroupPlay
      lesson={lesson}
      className={className}
      onSaveSuccess={onSaveSuccess}
    />
  );
}
